export const JiraLogo = require("./jira_logo.png");
export const GitHubLogo = require("./github_logo.png");
export const NotionLogo = require("./notion_logo.png");
export const DevlakeLogo = require("./devlake_logo.png");
export const VaultwardenLogo = require("./vaultwarden_logo.png");
export const SonarQubeLogo = require("./sonarqube_logo.png");
export const SentryLogo = require("./sentry_logo.png");
export const StructurizrLogo = require("./structurizr_logo.png");
export const PlantUMLLogo = require("./plantuml_logo.png");
